var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.previewHtml ? _c("div", [_c("cpsc-icon", {
    attrs: {
      hover: true,
      name: "el-icon-view"
    },
    on: {
      click: function click($event) {
        _vm.drawer = true;
      }
    }
  }), _c("el-drawer", {
    attrs: {
      title: _vm.title,
      visible: _vm.drawer,
      size: _vm.size,
      "append-to-body": true,
      "custom-class": "app-custom-drawer-scroll"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.drawer = $event;
      }
    }
  }, [_c("div", {
    staticClass: "pre-view"
  }, [_c("div", {
    staticClass: "editor-wrap custom-ck-editor-style isDocument"
  }, [_c("div", {
    staticClass: "ck-blurred ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-read-only",
    attrs: {
      lang: "en",
      dir: "ltr",
      role: "textbox",
      contenteditable: "false"
    },
    domProps: {
      innerHTML: _vm._s(_vm.previewHtml)
    }
  })])])])], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };